module.exports = __webpack_public_path__ + "static/img/icon-kpmglogo.37edd306.svg";